var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDown = function SvgDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 9,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m2.143.05 4.949 5.052 5.05-4.949 1.99 1.02-7.071 6.929L.133 1.03z"
  })));
};
export { SvgDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE1IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yLjE0MzE1IDAuMDUwODk2NEw3LjA5MTY3IDUuMTAxODZMMTIuMTQyNiAwLjE1MzMzOUwxNC4xMzIzIDEuMTczNzhMNy4wNjA5NCA4LjEwMTdMMC4xMzMwMTQgMS4wMzAzNkwyLjE0MzE1IDAuMDUwODk2NFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=";